import { useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import {
  accountStatusApi,
  authorizeApi,
  changePasswordApi,
  checkoutApi,
  clearStore,
  clearVipStatusData,
  generateVipStatusToken,
  getBannerApi,
  getBrandApi,
  getCheckoutProductsApi,
  getOrderDetailApi,
  getOrderHistoryApi,
  getPointHistoryApi,
  getProductDetailApi,
  getProductsApi,
  getProfile,
  getShippingDetailApi,
  getVipStatus,
  loginApi,
  logout,
  postGetDailyBonusApi,
  redeemCredit,
  removeUserCartItemApi,
  resetCheckedAllProduct,
  resetLockedAccount,
  resetPagination,
  resetShippingAddressApi,
  setStoreLanguage,
  updateCartApi,
  updateShippingAddressApi,
  updateUserCartItemApi,
} from "../store/actions";

import { useMemo } from "react";
import { launchPlaynow } from "src/main/store/layout/actions";
import {
  addCartItemApi,
  deleteCartItemApi,
  getCartItemApi,
  itemInCartList,
  itemInCartUpdate,
  productListingApi,
  resetProductListingPagination,
  topProductListingApi,
  updateCheckAllItem,
} from "src/main/store/product/actions";

const combinedActions = {
  clearStore,
  getProductsApi,
  getProductDetailApi,
  updateCartApi,
  getShippingDetailApi,
  checkoutApi,
  getCheckoutProductsApi,
  updateShippingAddressApi,
  changePasswordApi,
  getOrderHistoryApi,
  getPointHistoryApi,
  getOrderDetailApi,
  resetCheckedAllProduct,
  loginApi,
  accountStatusApi,
  authorizeApi,
  getBrandApi,
  resetShippingAddressApi,
  getProfile,
  setStoreLanguage,
  resetPagination,
  removeUserCartItemApi,
  updateUserCartItemApi,
  postGetDailyBonusApi,
  logout,
  getBannerApi,
  resetLockedAccount,
  getVipStatus,
  generateVipStatusToken,
  redeemCredit,
  launchPlaynow,
  productListingApi,
  resetProductListingPagination,
  topProductListingApi,
  itemInCartList,
  itemInCartUpdate,
  addCartItemApi,
  updateCheckAllItem,
  deleteCartItemApi,
  getCartItemApi,
  clearVipStatusData,
};

const useActions = () => {
  const dispatch = useDispatch();
  return useMemo(() => {
    return bindActionCreators(combinedActions, dispatch);
  }, [dispatch]);
};

export default useActions;
